import { DocType } from "./DocType";

export interface IdNames {
  docType: DocType;
  longName: string;
  shortName: string;
}

export class PrettyIdNames {
  private static ID_NAMES: IdNames[] = [
    {
      docType: DocType.LICENSE_FRONT,
      longName: "License Front",
      shortName: "ID",
    },
    {
      docType: DocType.LICENSE_BACK,
      longName: "License Back",
      shortName: "ID",
    },
  ];

  public static DEFAULT_ID_NAME: IdNames = {
      docType: DocType.OTHER,
      longName: "document",
      shortName: "document",
  };

  public static getIdNames = (docType: DocType): IdNames => {
    const names = PrettyIdNames.ID_NAMES.filter( (id) => id.docType === docType);

    if (names.length === 0) {
      return PrettyIdNames.DEFAULT_ID_NAME;
    }

    return names[0];
  };
}



// WEBPACK FOOTER //
// ./src/constants/PrettyIdNames.ts